import * as React from 'react'

import { cn } from '@/lib/utils'

export type DataRowStatus = 'ok' | 'watch'

export interface DataRow {
  label: string
  value: string
  status: DataRowStatus
  icon: React.ReactNode
}

export interface DataCardProps {
  rows: DataRow[]
  className?: string
  style?: React.CSSProperties
}

/**
 * Compliance/status summary. Dark-surface only, same as StepCard.
 *
 * Status color rule (see the design-system page → semantic intent): `ok`
 * uses `--green` (#31AB6A) and `watch` uses `--amber` — the semantic
 * status ramp, never the brand safety-green. Status is always an icon +
 * color pairing, never a standalone tag or pill.
 */
export function DataCard({ rows, className, style }: DataCardProps) {
  return (
    <div
      className={cn('grid gap-4 rounded-sm border border-white/16 bg-white/8 p-6', className)}
      style={style}
    >
      {rows.map((row) => (
        <div className="flex items-center justify-between gap-4 font-mono text-sm text-white" key={row.label}>
          <span className="text-white/78">{row.label}</span>
          <span
            className={cn(
              'inline-flex items-center gap-2 font-semibold [&_svg]:size-3.5 [&_svg]:flex-none',
              row.status === 'ok' ? 'text-accent-green' : 'text-(--amber)'
            )}
          >
            {row.icon}
            {row.value}
          </span>
        </div>
      ))}
    </div>
  )
}
